import { render } from "./WelcomeModal.vue?vue&type=template&id=3e8c22de&scoped=true"
import script from "./WelcomeModal.vue?vue&type=script&lang=js"
export * from "./WelcomeModal.vue?vue&type=script&lang=js"

import "./WelcomeModal.vue?vue&type=style&index=0&id=3e8c22de&scoped=true&lang=css"

import exportComponent from "/home/admin/domains/web3.owatts.io/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8c22de"]])

export default __exports__